import { useMemo } from 'react';

import type { Control } from '../constants/controls';
import { camera, invite, leave, microphone, screen } from '../constants/controls';

export function useControlView() {
    const controlList = useMemo<Control[]>(() => {
        const list: Control[] = [];

        list.push(microphone);
        list.push(camera);
        if (navigator.mediaDevices && 'getDisplayMedia' in navigator.mediaDevices) list.push(screen);
        list.push(invite);
        list.push(leave);

        return list;
    }, []);

    return controlList;
}
